import Datepicker from 'flowbite-datepicker/Datepicker';
import DateRangePicker from 'flowbite-datepicker/DateRangePicker';

if(!document.body.classList.contains('stop-common')){
    $(document).on('ready', function(){
    //init datepickers
    // $('.datepicker.datepicker-dropdown').remove();
    // $('[datepicker]').each(function(){
    //     var datePicker = new Datepicker($(this)[0], {
    //         format: $(this).attr('datepicker-format'),
    //     });

    //     $(datePicker.element).on('changeDate', function(){
    //         var val = $(datePicker.element).val();
    //         if(datePicker.element._x_model){
    //             datePicker.element._x_model.set(val);
    //         }

    //         const customEvent = new CustomEvent('dateupdated', {
    //         detail: {
    //             value: val,
    //         },
    //         });
    //         datePicker.element.dispatchEvent(customEvent);
    //     });

    //     $(this).on('input', function(){
    //         datePicker.update();
    //         datePicker.hide();
    //         $(this).blur();
    //     });
    // });

    // $('[date-rangepicker]').each(function(){
    //     new DateRangePicker($(this)[0], {
    //         // options
    //         format: "dd-mm-yyyy",
    //         minDate : new Date(),
    //     });
    // });
    
    var lastTouchEnd = 0;
    document.addEventListener('touchend', function (event) {
        var now = (new Date()).getTime();
        if (now - lastTouchEnd <= 300) {
            event.preventDefault();
        }
        lastTouchEnd = now;
    }, false);
    
    });

    function initializeLazyLoading() {
        let lazyImages = [].slice.call(document.querySelectorAll("img.lazy-load"));

        if ("IntersectionObserver" in window) {
            let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        let lazyImage = entry.target;
                        lazyImage.src = lazyImage.dataset.src;
                        lazyImage.classList.remove("lazy-load");
                        lazyImageObserver.unobserve(lazyImage);
                    }
                });
            }, {
                rootMargin: '1000px 0px', // Load images 100px before they are in view,
                // root: document.querySelector('.gallery-overlay'),
            });

            lazyImages.forEach(function(lazyImage) {
                lazyImageObserver.observe(lazyImage);
            });
        } else {
            // Fallback for browsers that do not support IntersectionObserver
            let lazyLoad = function() {
                lazyImages.forEach(function(lazyImage) {
                    if (lazyImage.getBoundingClientRect().top < window.innerHeight && lazyImage.getBoundingClientRect().bottom > 0 && getComputedStyle(lazyImage).display !== "none") {
                        lazyImage.src = lazyImage.dataset.src;
                        lazyImage.classList.remove("lazy-load");

                        lazyImages = lazyImages.filter(function(image) {
                            return image !== lazyImage;
                        });

                        if (lazyImages.length === 0) {
                            document.removeEventListener("scroll", lazyLoad);
                            window.removeEventListener("resize", lazyLoad);
                            window.removeEventListener("orientationchange", lazyLoad);
                        }
                    }
                });
            };

            document.addEventListener("scroll", lazyLoad);
            window.addEventListener("resize", lazyLoad);
            window.addEventListener("orientationchange", lazyLoad);
        }
    }

    document.addEventListener("DOMContentLoaded", function() {
        initializeLazyLoading();
    });

    window.addEventListener("images-loaded", function(){
        initializeLazyLoading();
    });
}